export default __webpack_public_path__ + "static/media/kimbu6.4122c822.jpg";